import { setBreadCrumbs } from '../../../../Services/BreadCrumbs.service';
import { setSelectedFolderId } from '../../../../Services/SelectedFolder.service';

const SetBreadcrumbsCorrectPath = (
  item: any,
  breadCrumbs: any,
  compId: string,
) => {
  const tempBreadCrumbs = [...breadCrumbs];
  const index = breadCrumbs.findIndex((element: any) => item.id === element.id);
  tempBreadCrumbs.splice(index + 1);
  setBreadCrumbs(tempBreadCrumbs, compId);
  setSelectedFolderId(item.id, compId);
};

export default SetBreadcrumbsCorrectPath;
